import { Link } from "react-router-dom";
import { MarketingLayout } from "../components/MarketingLayout";
import { Mic, Video, Sparkles, FileText, Zap, Globe, Users, Layers } from "lucide-react";
import AssetFanout from "../components/visuals/AssetFanout";
import FormatFrames from "../components/visuals/FormatFrames";

const FEATURES = [
  { icon: Mic, title: "Voice memo to script", desc: "Upload a voice note or type notes. AI structures your product story and writes narration." },
  { icon: Layers, title: "Screenshot storyboard", desc: "Arrange screenshots into scenes with voiceover, captions, and on-screen text per slide." },
  { icon: Video, title: "Polished video export", desc: "ffmpeg-rendered slideshow demos with TTS voiceover, captions, and optional background music." },
  { icon: Sparkles, title: "Launch kit generator", desc: "Product Hunt copy, LinkedIn posts, email announcements, ad scripts, and SEO meta — from one project." },
  { icon: FileText, title: "PDF product manual", desc: "Matching written documentation generated alongside your demo video." },
  { icon: Globe, title: "Multilingual dubs", desc: "Localize demos into Hindi, Tamil, Telugu, Bengali and more Indian languages, or English (India), with native voices." },
  { icon: Users, title: "Team workspaces", desc: "Collaborate with editors and viewers. Perfect for agencies shipping client demos." },
  { icon: Zap, title: "BYOK AI providers", desc: "Use OpenAI, Anthropic, Gemini, Groq, Sarvam, or ElevenLabs with your own keys." },
];

export default function Features() {
  return (
    <MarketingLayout>
      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="marquee-tag mb-4">// FEATURES</div>
        <h1 className="font-display font-black type-title-lg tracking-tighter mb-6">
          THE FASTEST WAY TO CREATE<br/><span className="text-ink-accent">SAAS DEMO VIDEOS.</span>
        </h1>
        <p className="type-lead text-ink-muted max-w-2xl mb-12">
          DemoCraft sits between screen recorders, video editors, and AI marketing assistants — purpose-built for product launches.
        </p>
        <div className="mb-12">
          <AssetFanout />
        </div>
        <div className="grid md:grid-cols-2 gap-0 brutal-border">
          {FEATURES.map(({ icon: Icon, title, desc }, i) => (
            <div key={title} className={`p-8 ${i % 2 === 1 ? "bg-surface" : "bg-white"} border-b brutal-border border-l-0 border-r-0 last:border-b-0`}>
              <Icon size={24} strokeWidth={2} className="text-ink-accent" />
              <h2 className="font-display font-black type-subheading mt-4 tracking-tight">{title}</h2>
              <p className="text-sm mt-2 text-ink-muted leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
        <div className="mt-12">
          <FormatFrames />
        </div>
        <div className="mt-12 text-center">
          <Link to="/register" className="brutal-btn">Start free — 3 demo projects</Link>
        </div>
      </section>
    </MarketingLayout>
  );
}
